import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NumberInputIntroduction from "../UI elements/NumberInput";
import IOSSwitch from "../UI elements/iOSswitch";
import axiosInstance from "../../../../../axiosInstance";
import { TextField } from "@mui/material";

const AISettings = (props) => {
  const [ChangesMade, setChangesMade] = useState(false);
  const [Settings, setSettings] = useState({ enabled: true, interval: 10 });
  const [Validation, setValidation] = useState({ hasError: false, text: "" });
  const [DummyImagesGenerated, setDummyImagesGenerated] = useState(0);
  const [UserImagesGenerated, setUserImagesGenerated] = useState(0);

  useEffect(() => {
    fetchStats();
    fetchSettings();
    fetchCreditUsage();
  }, []);

  const fetchSettings = () => {
    let Req = {
      method: "GET",
      baseURL:
        window.localStorage.getItem("BaseURL") +
        "/services/projectmanagement/api/system-settings/1",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };

    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        setSettings({
          enabled: Res.data.periodicRequestEnabled,
          interval: Res.data.periodicRequestInterval,
        });
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchStats = () => {
    let Req = {
      method: "GET",
      baseURL:
        window.localStorage.getItem("BaseURL") +
        "/services/projectmanagement/api/periodic-request-logs/count",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        setDummyImagesGenerated(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchCreditUsage = () => {
    let Req = {
      method: "GET",
      baseURL:
        window.localStorage.getItem("BaseURL") + "/api/user-credits/usage",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        setUserImagesGenerated(Res.data.total);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const handleSwitchChange = (e) => {
    setChangesMade(true);
    props.SetHasUnsavedChanges(true);
    setSettings({ ...Settings, enabled: e.target.checked });
  };

  const handleIntervalChange = (Value) => {
    setChangesMade(true);
    props.SetHasUnsavedChanges(true);
    setSettings({
      ...Settings,
      interval: Value,
    });
    if (Value.length === 0) {
      setValidation({ hasError: true, text: "Please enter a number" });
    } else if (Value < 5) {
      setValidation({ hasError: true, text: "Enter a number greater than 5" });
    } else {
      setValidation({ hasError: false, text: "" });
    }
  };

  const saveData = () => {
    let Req = {
      method: "PATCH",
      baseURL:
        window.localStorage.getItem("BaseURL") +
        "/services/projectmanagement/api/system-settings/1",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        id: 1,
        periodicRequestEnabled: Settings.enabled,
        periodicRequestInterval: Settings.interval,
      },
    };

    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);

        setChangesMade(false);
        setValidation({ hasError: false, text: "" });
        props.SetHasUnsavedChanges(false);
        props.SetModalIsOpen(false);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const handleCancel = (e) => {
    props.SetLastClickedId("cancel-btn");

    if (props.HasUnsavedChanges) {
      e.preventDefault();
      props.SetModalIsOpen(true);
    }
  };

  return (
    <div className="form-wrapper admin-panel-settings">
      <section className="form-head">
        <h1 className="head-title" style={{ left: "24px" }}>
          AI Settings
        </h1>
        <section className="head-actions">
          <span className="action-btn cancel">
            <Link id="cancel-btn" onClick={(e) => handleCancel(e)} to="/Home">
              Cancel
            </Link>
          </span>
          <span
            id="save-btn"
            className={
              ChangesMade && !Validation.hasError
                ? "action-btn save"
                : "action-btn save disabled"
            }
            onClick={() => saveData()}
          >
            Save
          </span>
        </section>
      </section>
      <div className="table-body">
        <section
          className="top-section"
          style={{ borderBottom: "none", marginBottom: "0" }}
        >
          <p className="section-label">Periodic requests</p>
          <section className="section-row">
            <p className="row-name">Enabled</p>
            {Settings.enabled !== undefined ? (
              <>
                <IOSSwitch
                  checked={Settings.enabled ? true : false}
                  onChange={handleSwitchChange}
                />
              </>
            ) : null}
          </section>
          <section className="section-row">
            <p className="row-name">Interval</p>
            <NumberInputIntroduction
              OnChange={(e) => handleIntervalChange(e)}
              Disabled={Settings.enabled ? false : true}
              Label="Minutes"
              CustomWidth={"190px"}
              Value={parseInt(Settings.interval)}
              HasError={Validation.hasError}
              ErrorText={Validation.text}
            />
          </section>
          <p className="section-label">Total images generated</p>
          <section className="section-row">
            <p className="row-name">Dummy images</p>
            <TextField
              autoComplete="off" // Disable autofill
              fullWidth
              id="total-images"
              name="total-images"
              label={"Total dummy images generated"}
              disabled
              placeholder={""}
              variant="outlined"
              value={DummyImagesGenerated}
              onChange={null}
              margin="normal"
              sx={{
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "#FB4764", // Change border color when focused
                  },
                backgroundColor: "transparent",
                borderRadius: "4px",
                width: "280px",
                borderBottom: "none",
              }}
            />
          </section>
          <section className="section-row">
            <p className="row-name">All-time images</p>
            <TextField
              autoComplete="off" // Disable autofill
              fullWidth
              id="total-images"
              name="total-images"
              label={"Total images generated"}
              disabled
              placeholder={""}
              variant="outlined"
              value={UserImagesGenerated}
              onChange={null}
              margin="normal"
              sx={{
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "#FB4764", // Change border color when focused
                  },
                backgroundColor: "transparent",
                borderRadius: "4px",
                width: "280px",
                borderBottom: "none",
              }}
            />
          </section>
        </section>
      </div>
    </div>
  );
};

export default AISettings;
